import React from 'react';
import {MetricsElement} from 'react-metrics';

import withUserInput from '../../ui/components/with-user-input-type';
import ProductPriceV2 from './product-price/product-price-v2';
import ProductCTA from './product-cta';
import CompareCheckbox from '../../compare/components/compare-checkbox';
import IntraDayDeals from './deals';
import Link from '../../shared/components/hyperlink';
import LoyaltyBadge from './loyalty-badge';
import Button from '../../ui/components/button';
import '../../product/css/product-card-footer.less';

const EMTPY_OBJECT = {};

const ProductCartCTA = withUserInput(({ productUrl, product, jumpid, text, ctaMetrics, productClickMetrics, baseProductSku, xsellType, popupConfig, templateKey }) => {
    let link = (
        <Link to={productUrl} className="btn prd-card-view-details" {...productClickMetrics || {}}>View Details</Link>
    );

    let linkComponent = (
        productClickMetrics
        ? <MetricsElement>{link}</MetricsElement>
        : link
    );

    return <div className="prd-card-cta">
        <Button
            type={'tertiary'}
            variation={'left'}
            text={'View Details'}
            linkComponent={linkComponent}
            action={'go'}
            className='view-details'
        />
        <ProductCTA
            product={product}
            jumpid={jumpid}
            ctaText={text}
            enableAddToQuote={true}
            isV2={true}
            ctaMetrics={ctaMetrics}
            baseProductSku={baseProductSku} 
            xsellType={xsellType}
            popupConfig={popupConfig}
            templateKey={templateKey}
        />
    </div>
})

const ProductCardFooter = ({ product, productUrl, jumpid, text, ctaMetrics, productClickMetrics, baseProductSku, xsellType, templateKey, popupConfig }) => {
    const { attributes = EMTPY_OBJECT } = product;
    const { loyalty_multiplier } = attributes;

    return (
        <div className="prd-card-footer">
            <IntraDayDeals itemId={product.itemId}>
                {dealProps => {
                    const { isActive, productDeals } = dealProps;
                    const deal = isActive ? productDeals.activeDeal : null;
                    return (
                        <ProductPriceV2
                            product={product} 
                            deal={deal}
                            className='prod-card-price'
                            displayDifference={true} 
                            style={'center'}
                            useSmallPrice={true}
                        />
                    );
                }}
            </IntraDayDeals>
            {loyalty_multiplier && (
                <div className="subline">
                    <CompareCheckbox
                        product={product}
                        btnText={'Add to compare'}
                        selectedText={'Selected to compare'}
                    />
                    <LoyaltyBadge multiplier={loyalty_multiplier} type={'productCard'} />
                </div>
            )}
            {!loyalty_multiplier && (
                <CompareCheckbox
                    product={product}
                    btnText={'Add to compare'}
                    selectedText={'Selected to compare'}
                />
            )}
            <ProductCartCTA productUrl={productUrl} product={product} ctaText={text} popupConfig={popupConfig} templateKey={templateKey}
                            ctaMetrics={ctaMetrics} productClickMetrics={productClickMetrics} baseProductSku={baseProductSku} xsellType={xsellType}/>
        </div>
    );
};

export default ProductCardFooter;
